/*
 * @Author: Scherger 
 * @Date: 2018-05-11 09:39:09 
 * @Last Modified by: Scherger
 * @Last Modified time: 2021-07-26 11:02:17
 * @Description: 表单信息判断方法
 */


/*
 *
 *   调用方式
 * 
 *      //表單驗證
 *       import DatorFun from "@/utils/censor.js";
 *
 *       进行实例化  let dator = new DatorFun.Dator();
 *
 *    
 *   使用方式
 *
 *       decide.add('',[
 *         { strategy:'isEmpty','errMsg':'空' }，
 *         { strategy: 'checkLength:11:1', errMsg: '长度错误' }, // checkLength 是判断的类型方法  ， 11 是需要鉴定的长度  ，  1 是验证的方式是那种 ， 用 : 分割   
 *       ])
 *
 */

var SchergerFun = {
    //判空
    isEmpty: function (value, errMsg) {
      if (value === '' || !value) {
        return errMsg;
      }
    },
    //判断是否为数字
    checkNumber: function (value, errMsg) {
      //非负浮点数
      // var regPos = /^\d+(\.\d+)?$/; 
      //负浮点数
      // var regNeg = /^(-(([0-9]+\.[0-9]*[1-9][0-9]*)|([0-9]*[1-9][0-9]*\.[0-9]+)|([0-9]*[1-9][0-9]*)))$/;
      //判断正整数 
      var re = /^[1-9]+[0-9]*]*$/
      //判断字符串是否为数字
      // var re = /^[0-9]+.?[0-9]*$/;
  
      // var re = /^1(3|4|5|7|8)\d{9}$/;  
  
      if (!re.test(value)) {
        return errMsg;
      }
  
    },
  
    //判断手机号格式
    checkPhone: function (value, errMsg) {
      //手机正则   && !value.toString().length == 11
      var phoneStr = /^1[3|4|5|6|7|8|9][0-9]\d{4,8}$/;
      //电话号码长度11位
      if (!phoneStr.test(value)) {
        return errMsg;
      }
    },
  
    //判断香港手機號第一位數字2/3/5/6/8/9
    checkHkPhone: function (value, errMsg) {
      //檢查香港手機號碼
      let falg = true
  
      if (typeof value == 'String' || typeof value == 'string') {
  
        if (value.charAt(0) == 2 || value.charAt(0) == 3 || value.charAt(0) == 4 || value.charAt(0) == 5 || value.charAt(0) == 6 || value.charAt(0) == 8 || value.charAt(0) == 9|| value.charAt(0) == 1|| value.charAt(0) == 7) {
          falg = false
        }
  
      } else {
        console.error('value值必須爲字符串');
      }
      if (falg) {
        return errMsg;
      }
    },
  
  
    //判断字符串
    checkStringFormat: function (value, len, flag, errMsg) {
      flag *= 1;
      switch (flag) {
  
        case 1: //验证全等
          if (value.toString().length != len * 1) {
            return errMsg
          }
          break;
        case 2: //验证大于
          if (value.toString().length > len * 1) {
            return errMsg
          }
          break;
  
        case 3: //验证大于等于
          if (value.toString().length >= len * 1) {
            return errMsg
          }
          break;
        case 4: //验证小于
          if (value.toString().length < len * 1) {
            return errMsg
          }
          break;
        case 5: //验证小于等于
          if (value.toString().length <= len * 1) {
            return errMsg
          }
          break;
      }
  
    },
    //判断数字
    checkNumberFormat: function (value, len, flag, errMsg) {
      flag *= 1;
      switch (flag) {
  
        case 1: //验证全等
          if (value != len * 1) {
            return errMsg
          }
          break;
        case 2: //验证大于
          if (value > len * 1) {
            return errMsg
          }
          break;
  
        case 3: //验证大于等于
          if (value >= len * 1) {
            return errMsg
          }
          break;
        case 4: //验证小于
          if (value < len * 1) {
            return errMsg
          }
          break;
        case 5: //验证小于等于
          if (value <= len * 1) {
            return errMsg
          }
          break;
      }
  
    },
    //验证密码
    checkPassworld: function (value, errMsg) {
      //密码正则数字加字母
      var passworldStr = /[A-Za-z].*[0-9]|[0-9].*[A-Za-z]/;
      if (!passworldStr.test(value)) {
        return errMsg;
      }
    },
    //验证邮箱(目前有点问题)
    checkEmail: function (value, errMsg) {
      // var emailStr = /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
      var emailStr = /^([a-zA-Z]|[0-9])(\w|\-|\.)+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
      if (!emailStr.test(value)) {
        return errMsg;
      }
    },
  
    //验证邮箱
    checkName: function (value, errMsg) {
      var emailStr = /^([a-zA-Z0-9_\u4e00-\u9fa5\.\-\-]){2,12}$/;
      if (!emailStr.test(value)) {
        return errMsg;
      }
    },
  
    //判断两个数据是否相等
    checkEqual: function (value, checkValue, errMsg) {
      if (value.toString() != checkValue.toString()) {
        return errMsg;
      }
    },
    
    //姓名
    checkUserName: function (value, errMsg) {
      // var emailStr = /[^\a-\z\A-\Z\u4E00-\u9FA5\ ]/g;
      var emailStr =/^[A-Za-z\u4e00-\u9fa5\s]*$/
      if (!emailStr.test(value)) {
        return errMsg;
      }
    },

     //你暱稱
     checkNickName: function (value, errMsg) {
      var emailStr = /^[A-Za-z0-9\u4e00-\u9fa5\s]*$/;
      if (!emailStr.test(value)) {
        return errMsg;
      }
    },

  }
  
  
  var SchergerDator = function () {
    this.cache = [];
  }
  
  SchergerDator.prototype.add = function (value, rules) {
    //根据添加的信息进行分配至相应的逻辑判断
    var that = this;
    for (var i = 0; i < rules.length; i++) {
      var strategyAry = rules[i].strategy.split(":");
      var errMsg = rules[i].errMsg;
  
      var strategy = strategyAry.shift();
  
      strategyAry.unshift(value);
      strategyAry.push(errMsg)
      // return [strategyAry]
      this.cache.push(SchergerFun[strategy].apply(value, strategyAry))
    }
  
  }
  
  SchergerDator.prototype.getErrmsg = function () {
    //若存在信息，即返回第一条信息（有多条信息，也只返回第一条）
    for (var i = 0; i < this.cache.length; i++) {
      if (this.cache[i]) {
        return this.cache[i]
      }
    }
  
  }
  
  SchergerDator.prototype.getAllErrmsg = function () {
  
    return this.cache
  
  }
  
  
  
  export default {
    Dator: SchergerDator
  }
  
  
  // module.exports = {
  //   dator: SchergerDator,
  // }